import { useEffect, useRef, useState, memo } from 'react'
import { QuickSelectionContainer } from '../../../styled-components'
import ContextMenuComponent from '../../../../context-menu'

import { QuickSelectContext } from './quick-select-context.jsx'

const QuickSelectRoot = ({ children, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef()

  const handleClose = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    const handleEsc = (event) => event.key === 'Escape' && handleClose()
    const handleClick = (event) =>
      !containerRef.current?.contains(event.target) && handleClose()

    document.addEventListener('keydown', handleEsc)
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('keydown', handleEsc)
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  return (
    <QuickSelectContext.Provider
      value={{
        isOpen,
        setIsOpen
      }}
    >
      <QuickSelectionContainer ref={containerRef} {...props}>
        <ContextMenuComponent.Root
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          style={{
            width: '100%'
          }}
        >
          {children}
        </ContextMenuComponent.Root>
      </QuickSelectionContainer>
    </QuickSelectContext.Provider>
  )
}

export default memo(QuickSelectRoot)
